module.exports = __webpack_public_path__ + "img/img-d3d575.png";